import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetClubhouseMembers, NewClubhouse } from "../services/clubhouseAPI";
import { ClubhouseFeed } from "../services/clubhouseFeedAPI";

type NewClubhouseState = {
  joinedClubhouses: NewClubhouse[];
  pinnedClubhouses: NewClubhouse[];
  mutedClubhouses: NewClubhouse[];
  clubhouseMembers: GetClubhouseMembers[];
  joinableClubhouses: NewClubhouse[];
};

const toggleClubhousePinnedCb = (
  clubhouse: NewClubhouse,
  newClubhouse: NewClubhouse
) => {
  if (clubhouse?._id === newClubhouse?._id) {
    return newClubhouse;
  }
  return clubhouse;
};

const updateUnseenActivityCb = (
  clubhouse: NewClubhouse,
  clubhouseId: string
) => {
  if (clubhouse?._id === clubhouseId) {
    return {
      ...clubhouse,
      unseenActivity: false,
    };
  }
  return clubhouse;
};

const newClubhouseSlice = createSlice({
  name: "chFeed",
  initialState: {
    joinedClubhouses: [],
    pinnedClubhouses: [],
    mutedClubhouses: [],
    clubhouseMembers: [],
    joinableClubhouses: [],
  } as NewClubhouseState,
  reducers: {
    setJoinedClubhouses: (
      state,
      {
        payload: { clubhouses, reset = false, add = false },
      }: PayloadAction<{
        clubhouses: NewClubhouse[] | NewClubhouse;
        add?: boolean;
        reset?: boolean;
      }>
    ) => {
      if (reset) {
        state.joinedClubhouses = clubhouses as NewClubhouse[];
      } else if (add) {
        const mergedClubhouses = [...state.joinedClubhouses, clubhouses];
        state.joinedClubhouses = mergedClubhouses as NewClubhouse[];
      } else {
        const isPresent = state.joinedClubhouses.find(
          (ch) => ch?._id === (clubhouses as NewClubhouse)?._id
        );
        if (isPresent) {
          const newList = state.joinedClubhouses.map((ch) =>
            toggleClubhousePinnedCb(ch, clubhouses as NewClubhouse)
          );
          state.joinedClubhouses = newList;
        } else {
          const mergedClubhouses = [
            ...state.joinedClubhouses,
            ...(clubhouses as NewClubhouse[]),
          ];
          // const mergedClubhouses = [
          //   ...state.joinedClubhouses,
          //   ...(clubhouses as NewClubhouse[]),
          // ];
          state.joinedClubhouses = mergedClubhouses as NewClubhouse[];
        }
      }
    },
    setPinnedClubhouses: (
      state,
      {
        payload: { clubhouses, reset = false, filter = false },
      }: PayloadAction<{
        clubhouses: NewClubhouse[] | NewClubhouse;
        reset?: boolean;
        filter?: boolean;
      }>
    ) => {
      if (reset) {
        state.pinnedClubhouses = clubhouses as NewClubhouse[];
      } else {
        const isPresent = state.pinnedClubhouses.find(
          (ch) => ch?._id === (clubhouses as NewClubhouse)?._id
        );
        if (isPresent && filter) {
          const newList = state.pinnedClubhouses.filter(
            (ch) => ch?._id !== (clubhouses as NewClubhouse)?._id
          );
          state.pinnedClubhouses = newList;
        } else if (isPresent) {
          const newList = state.pinnedClubhouses.map((ch) =>
            toggleClubhousePinnedCb(ch, clubhouses as NewClubhouse)
          );
          state.pinnedClubhouses = newList;
        } else {
          const mergedClubhouses = [...state.pinnedClubhouses, clubhouses];
          state.pinnedClubhouses = mergedClubhouses as NewClubhouse[];
        }
      }
    },

    setMutedClubhouses: (
      state,
      {
        payload: { clubhouses, reset = false },
      }: PayloadAction<{
        clubhouses: NewClubhouse[] | NewClubhouse;
        reset?: boolean;
      }>
    ) => {
      if (reset) {
        state.mutedClubhouses = clubhouses as NewClubhouse[];
      } else {
        const isPresent = state.mutedClubhouses.find(
          (ch) => ch?._id === (clubhouses as NewClubhouse)?._id
        );
        if (isPresent) {
          const newList = state.mutedClubhouses.filter(
            (ch) => ch?._id !== (clubhouses as NewClubhouse)?._id
          );
          state.mutedClubhouses = newList;
        } else {
          const mergedClubhouses = [...state.mutedClubhouses, clubhouses];
          state.mutedClubhouses = mergedClubhouses as NewClubhouse[];
        }
      }
    },
    setJoinableClubhouses: (
      state,
      {
        payload: { clubhouses, reset = false },
      }: PayloadAction<{
        clubhouses: NewClubhouse[] | NewClubhouse;
        reset?: boolean;
      }>
    ) => {
      // if (reset) {
      //   state.mutedClubhouses = clubhouses as NewClubhouse[];
      // } else {
      //   const isPresent = state.mutedClubhouses.find(
      //     (ch) => ch?._id === (clubhouses as NewClubhouse)?._id
      //   );
      //   if (isPresent) {
      //     const newList = state.mutedClubhouses.filter(
      //       (ch) => ch?._id !== (clubhouses as NewClubhouse)?._id
      //     );
      //     state.mutedClubhouses = newList;
      //   } else {
      const mergedClubhouses = [...state.mutedClubhouses, clubhouses];
      state.mutedClubhouses = mergedClubhouses as NewClubhouse[];
      // }
      // }
    },
    setUnseenActivity: (
      state,
      {
        payload: { clubhouseId },
      }: PayloadAction<{
        clubhouseId: string;
      }>
    ) => {
      const updatedClubhouseList = state.joinedClubhouses.map((clubhouse) =>
        updateUnseenActivityCb(clubhouse, clubhouseId)
      );
      state.joinedClubhouses = updatedClubhouseList;
    },
  },
});

export const {
  setJoinedClubhouses,
  setPinnedClubhouses,
  setMutedClubhouses,
  setJoinableClubhouses,
  setUnseenActivity,
} = newClubhouseSlice.actions;

export default newClubhouseSlice.reducer;
